import {createReducer} from '@reduxjs/toolkit'
import {closeNativeModal, openNativeModal, openUpgradeToPremium, openCheckoutUnavailable} from '../actions/modals'
import {ModalsState} from '../types'

const defaultState: ModalsState = {
  modalType: '',
}

export const modals = createReducer(defaultState, builder => {
  builder
    .addCase(openNativeModal, (state, action) => ({modalType: action.payload}))
    .addCase(closeNativeModal, () => defaultState)
    .addCase(openUpgradeToPremium.pending, () => defaultState)
    .addCase(openCheckoutUnavailable.pending, () => defaultState)
})
